/* ============================================================
   Mixtape® — LISTAS
   ============================================================ */

import { ncs } from "./playlists/ncs"
import { pop2026 } from "./playlists/pop"
import { roomedition } from "./playlists/roomedition"
import { radioshow } from "./playlists/radioshow"
import { topurbano } from "./playlists/topurbano"
import { cluburban } from "./playlists/cluburban"
import { trapincoming } from "./playlists/trapincoming"
import { platjadesitges } from "./playlists/platjadesitges"
import { remixes } from "./playlists/remixes"
import { okioset } from "./playlists/okioset"
import { selectiva } from "./playlists/amy"

/* ============================================================
   Catálogo completo
   ============================================================ */

export const LISTAS = [
  ncs,
  pop2026,
  roomedition,
  radioshow,
  topurbano,
  cluburban,
  trapincoming,
  platjadesitges,
  remixes,
  okioset,
  selectiva
]
